import { render, staticRenderFns } from "./starLevel.vue?vue&type=template&id=3ccfbc34&scoped=true"
import script from "./starLevel.vue?vue&type=script&lang=js"
export * from "./starLevel.vue?vue&type=script&lang=js"
import style0 from "./starLevel.vue?vue&type=style&index=0&id=3ccfbc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfbc34",
  null
  
)

export default component.exports